import React, { memo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';

import { ADGMTextField, ADGMImage } from 'aurora-components';

import styles from './styles';

const FiltersSearchField = ({ classes, value, placeHolder, onChange, onSearchHandler }) => {
  const handleChange = e => {
    const { value: data } = e.target;
    onChange(data);
  };

  return (
    <ADGMTextField
      id='search'
      name='search'
      value={value ?? ''}
      placeholder={placeHolder}
      endAdornment={
        <Button className={classes.searchBtn} onClick={onSearchHandler}>
          <ADGMImage name='search_icon_white.svg' alt='search' />
        </Button>
      }
      onChange={handleChange}
      customClasses={{
        field: classes.field,
        input: classes.input,
      }}
    />
  );
};

FiltersSearchField.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.any,
  placeHolder: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearchHandler: PropTypes.func.isRequired,
};

FiltersSearchField.defaultProps = {
  value: '',
};
export default withStyles(styles)(memo(FiltersSearchField));
